import React, { useState } from 'react';
import { SectionTitle } from '@/components/ui/shared/section-title';
import { LandscapeDescription } from '@/types';
import { LandscapeSpecifications } from './specifications';
import Link from 'next/link';
import { MoveRight } from 'lucide-react';
import { lexicalStateToHtml } from '@/lib/utils/lexical-to-html';

interface Specification {
  value: string | number | { id: number; title: string; updatedAt?: string; createdAt?: string } | null;
  light?: boolean;
  url?: string;
}

interface Specs {
  label: string;
  specifications: Specification[];
}

interface LandscapeDescriptionProps {
  layout: LandscapeDescription;
  specs: Specs[];
}

export const Landscape_Description: React.FC<LandscapeDescriptionProps> = ({ layout, specs }) => {
  const [isOpen, setIsOpen] = useState(false); // İlk öğe açık gelecek

  return (
    <div>
      <div className="content-section rounded-md mb-[12px]">
        <div className="pt-[15px] w-full px-[15px] rounded-md">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 font-mono text-[10px] pt-2 pb-12">
            {specs.length > 0 && <div className="pr-0 lg:pr-16 lg:mb-8">
              <LandscapeSpecifications title="INFORMATION" sectionClassName="mb-5" specs={specs} />
            </div>}

            <div className={specs.length ? undefined : 'lg:col-start-2'}>
              <SectionTitle title={layout.title} className={'mb-5 mt-8 lg:mt-0'} />
              <div
                className={`space-y-4 text-[10px] leading-relaxed text-gray-500 columns-1 ${
                  layout.column === 2
                    ? 'lg:columns-2'
                    : layout.column === 3
                      ? 'lg:columns-3'
                      : layout.column === 4
                        ? 'lg:columns-4'
                        : ''
                } mb-8 lg:mb-0`}
              >
                {layout.description.split('\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>

              {layout.additionalTitle && layout.additionalDescription && (
                <div
                  className={`mt-8 overflow-hidden transition-all duration-500 ease-in origin-top transform ${
                    isOpen
                      ? 'max-h-[1000px] opacity-100 scale-y-100 translate-y-0 mb-4'
                      : 'max-h-0 opacity-0 scale-y-95 -translate-y-2'
                  }`}
                >
                  <SectionTitle title={layout.additionalTitle} className={'mb-5 lg:mt-0'} />
                  <div
                    className={`space-y-4 text-[10px] leading-relaxed text-gray-500 columns-1 ${
                      layout.column === 2
                        ? 'lg:columns-2'
                        : layout.column === 3
                          ? 'lg:columns-3'
                          : layout.column === 4
                            ? 'lg:columns-4'
                            : ''
                    } mb-8 lg:mb-0`}
                  >
                    <div
                      className="pt-2 pb-1 [&>p]:mb-3"
                      dangerouslySetInnerHTML={{
                        __html: layout.additionalDescription
                          ? lexicalStateToHtml(layout.additionalDescription)
                          : '',
                      }}
                    />
                  </div>
                </div>
              )}

              {layout.additionalTitle && (
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="cursor-pointer text-gray-500 text-[10px] 
                  mb-2 inline-flex items-center gap-[5px] select-none
                  border-[#D9D9D9] border-[1px] px-[8px] py-[2px] rounded-md uppercase
                  "
                >
                  <span>
                    {isOpen ? 'HIDE' : 'READ'} {layout.additionalTitle}
                  </span>
                  <MoveRight className={`text-gray-500 w-2 transition-transform ${isOpen ? '-rotate-90' : ''}`} />
                </div>
              )}

              {layout.urlTitle && layout.url && (
                <Link
                  href={layout.url}
                  className="px-3 py-2 my-4 inline-block uppercase text-gray-500 rounded-sm transition-colors border bg-white hover:bg-gray-100 border-gray-200"
                >
                  {layout.urlTitle}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
